






























import { Action, State } from "vuex-class";
import { Component, Vue } from "vue-property-decorator";
import { SnackbarState } from "@/models/store/SnackbarState";

const namespace = "snackbar";

@Component({
  name: "AppSnackbar"
})
export default class AppSnackbar extends Vue {
  // ===== Store ===== //
  @State("snackbar") public snackbar!: SnackbarState;
  @Action("clearMessage", { namespace }) public clearMessage!: () => void;
}
